module.exports = __webpack_public_path__ + "static/media/tr-TR.23e7aeec.md";